module.exports = __webpack_public_path__ + "assets/img/tag_icon.1c66e775.svg";